export default "__VITE_ASSET__w4bJRF_J__"